import { render } from "./QueueDetailTableOrigin.vue?vue&type=template&id=4e6077aa"
import script from "./QueueDetailTableOrigin.vue?vue&type=script&lang=js"
export * from "./QueueDetailTableOrigin.vue?vue&type=script&lang=js"

import "./QueueDetailTableOrigin.vue?vue&type=style&index=0&id=4e6077aa&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__